function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8 7C8 6.72386 7.77614 6.5 7.5 6.5H4.5C4.22386 6.5 4 6.72386 4 7V10C4 10.2761 4.22386 10.5 4.5 10.5H7.5C7.77614 10.5 8 10.2761 8 10V7ZM3 4.5C2.44772 4.5 2 4.94772 2 5.5V11.5C2 12.0523 2.44772 12.5 3 12.5H9C9.55228 12.5 10 12.0523 10 11.5V5.5C10 4.94772 9.55228 4.5 9 4.5H3Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10 7.94152V9.05848L11.3419 9.50578C11.6657 9.6137 12 9.37271 12 9.03143V7.96856C12 7.62729 11.6657 7.3863 11.3419 7.49422L10 7.94152ZM8.68377 6.27208C8.27543 6.40819 8 6.79033 8 7.22076V9.77924C8 10.2097 8.27543 10.5918 8.68377 10.7279L12.6838 12.0613C13.3313 12.2771 14 11.7951 14 11.1126V5.88743C14 5.20487 13.3313 4.7229 12.6838 4.93874L8.68377 6.27208Z"
});

function SvgPerspective(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    fill: "#777E90",
    viewBox: "0 0 16 17",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerspective);
export default __webpack_public_path__ + "static/media/perspective.e1d02a79.svg";
export { ForwardRef as ReactComponent };